<script>
import alertDescriptions from '../../model/v1/slotAlerts';
import ConsecutiveShiftsLimitIcon from '../icons/ConsecutiveShiftsLimitIcon.vue';
import InsufficientVacationIcon from '../icons/InsufficientVacationIcon.vue';
import MonthlyShiftLimitIcon from '../icons/MonthlyShiftLimitIcon.vue';
import NGStaffPairingIcon from '../icons/NGStaffPairingIcon.vue';
import PaperPlaneIcon from '../icons/PaperPlaneIcon.vue';
import UnassignedStaffIcon from '../icons/UnassignedStaffIcon.vue';

export default {
  props: {
    numReadComments: Number,
    numUnreadComments: Number,
    isClone: Boolean,
    shouldShowAlert: {
        type: Boolean,
        default: false,
    },
    alertIndex: {
        type: Number,
        default: 0,
    },
    askStatus: {
        type: Number,
        default: 0,
    },
    spotWorkAsk: {
      type: Number,
      default: 0,
    },
    tooltipBottom: Boolean,
  },
  computed: {
    slotTopRightStyle() {
        return {
            'right': this.tooltipBottom ? '-2px' : '',
        }
    },
    displayUnreadCommentsCount() {
        return this.numUnreadComments > 9 ? '9+' : this.numUnreadComments;
    },
    displayReadCommentsCount() {
        return this.numReadComments > 9 ? '9+' : this.numReadComments;
    },
    displayReadCommentBadge() {
        return this.numReadComments && !this.isClone;
    },
    isAsked() {
        return this.askStatus > 0;
    },
    askedBadgeClass() {
        return {
            'asked-badge-accepted': this.askStatus === 2,
            'asked-badge-rejected': this.askStatus === 3,
        }
    },
    askedSlotTooltipText() {
        return this.askStatus === 3 ? '要請が承認されませんでした' : '要請';
    },
    alertDescription() {
        return this.alertIndex ? alertDescriptions[this.alertIndex] : "";
    },
  },
  components: {
    PaperPlaneIcon,
    UnassignedStaffIcon,
    ConsecutiveShiftsLimitIcon,
    MonthlyShiftLimitIcon,
    InsufficientVacationIcon,
    NGStaffPairingIcon,
  }
};
</script>

<template>
    <!-- Top Right Slot Badges -->
    <div class="slot-top-right" :style="slotTopRightStyle">
        <span v-if="numUnreadComments" class="circle-container comment-number-badge">{{ displayUnreadCommentsCount }}</span>
        <span v-else-if="displayReadCommentBadge" class="circle-container comment-number-badge comment-read-badge">{{ displayReadCommentsCount }}</span>

        <span v-if="isAsked" class="tooltip tooltip-left text-warning circle-container asked-badge" :class="askedBadgeClass" :data-tooltip="askedSlotTooltipText">
            <PaperPlaneIcon class="text-light"/>
        </span>
        <span v-if="spotWorkAsk !== 0" class="tooltip tooltip-left text-warning circle-container asked-badge asked-badge-spotwork" data-tooltip="募集中">
            <PaperPlaneIcon class="text-light"/>
        </span>
        <span v-if="shouldShowAlert" class="tooltip tooltip-left circle-container alert-badge" :data-tooltip="alertDescription">
            <UnassignedStaffIcon v-if="alertIndex === 1"/>
            <ConsecutiveShiftsLimitIcon v-else-if="alertIndex === 2"/>
            <MonthlyShiftLimitIcon v-else-if="alertIndex === 3"/>
            <InsufficientVacationIcon v-else-if="alertIndex === 4"/>
            <NGStaffPairingIcon v-else-if="alertIndex === 5"/>
            <i v-else-if="alertIndex === 6" class="zmdi zmdi-close zmdi-hc-lg"></i>
            <div v-else>!</div>
        </span>
        <span class="overtime-slot-badge">
          <svg width="16" height="16" viewBox="-1 -1 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="7" cy="7" r="7.5" stroke="white" stroke-width="1"/>
            <path d="M7 0C8.85652 0 10.637 0.737498 11.9497 2.05025C13.2625 3.36301 14 5.14348 14 7C14 8.85652 13.2625 10.637 11.9497 11.9497C10.637 13.2625 8.85652 14 7 14C5.14348 14 3.36301 13.2625 2.05025 11.9497C0.737498 10.637 0 8.85652 0 7C0 5.14348 0.737498 3.36301 2.05025 2.05025C3.36301 0.737498 5.14348 0 7 0Z" fill="white"/>
            <path d="M7 0C8.85652 0 10.637 0.737498 11.9497 2.05025C13.2625 3.36301 14 5.14348 14 7C14 8.85652 13.2625 10.637 11.9497 11.9497C10.637 13.2625 8.85652 14 7 14C5.14348 14 3.36301 13.2625 2.05025 11.9497C0.737498 10.637 0 8.85652 0 7C0 5.14348 0.737498 3.36301 2.05025 2.05025C3.36301 0.737498 5.14348 0 7 0ZM6.34375 3.28125V7C6.34375 7.21875 6.45312 7.42383 6.63633 7.54688L9.26133 9.29688C9.56211 9.49922 9.96953 9.41719 10.1719 9.11367C10.3742 8.81016 10.2922 8.40547 9.98867 8.20312L7.65625 6.65V3.28125C7.65625 2.91758 7.36367 2.625 7 2.625C6.63633 2.625 6.34375 2.91758 6.34375 3.28125Z" fill="#FA7A7A"/>
          </svg>
        </span>
        <span class="interval-slot-badge tooltip tooltip-top" data-tooltip="勤務間インターバルが不足しています">
            <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.47003 1.7833C5.92765 0.990689 7.07169 0.990689 7.52931 1.7833L11.6479 8.91683C12.1055 9.70945 11.5334 10.7002 10.6182 10.7002H2.38113C1.46589 10.7002 0.893873 9.70945 1.35149 8.91683L5.47003 1.7833Z" fill="#F71515"/>
                <path d="M4.44029 1.18892C5.35552 -0.396307 7.64448 -0.396307 8.55971 1.18892L12.678 8.32245C13.5931 9.90767 12.4487 11.8892 10.6183 11.8892H2.38173C0.551295 11.8892 -0.593139 9.90767 0.322019 8.32245L4.44029 1.18892ZM7.52986 1.78338C7.07224 0.990768 5.92776 0.990768 5.47014 1.78338L1.35188 8.91691L1.27757 9.06785C0.987678 9.77905 1.45346 10.5847 2.21454 10.6887L2.38173 10.7003H10.6183C11.4762 10.7003 12.033 9.82971 11.7224 9.06785L11.6481 8.91691L7.52986 1.78338Z" fill="white"/>
            </svg>
        </span>
    </div>
</template>

<style scoped>
.comment-read-badge {
  background-color: #B1BABE;
}

.overtime-slot-badge,
.interval-slot-badge {
  display: none;
}
</style>

<style>
.overtime-active .has-overtime .overtime-slot-badge,
.has-interval-alert .interval-slot-badge {
  display: block;
}
</style>
